import React from 'react';
import './Footer.css';
const FixedFooter = () => {
  const currentYear = new Date().getFullYear(); 
  const footerStyle = {
    margin: '0px -154px',
    position: 'fixed',
    bottom: '0',
    width: '100%',
    height: '60px',
    backgroundColor: '#343a40', // Dark background
    color: '#fff', // White text color
    fontSize: '14px',
    textAlign: 'center',
    padding: '10px 0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: '999',
  };

  const linkStyle = {
    color: '#00bcd4', // Light blue color for links
    textDecoration: 'none',
  };

  const sectionStyle = {
    padding: '20px',
    backgroundColor: '#f7f7f7',
    height: '300px',
  };

  return (



    <div className="row">
    <div className="col-md-12">
        <div className="copyright">
            <p>Copyright © {currentYear}  All rights reserved by <a href="">VDC</a>.</p>
        </div>
    </div>
</div>


    
  );
};

export default FixedFooter;
